import addDays from "../../utils/date-utils/addDays";
import { getDateForHome } from "../../dweb-cars/shared/config/utils";
import dateformat from "dateformat";
export const getUrlParams = (url: string) =>
  `${url}?`
    .split("?")[1]
    .split("&")
    .reduce(
      (params, pair) =>
        ((key, val) => (key ? { ...params, [key]: val } : params))(
          ...`${pair}=`.split("=").map(decodeURIComponent)
        ),
      {}
    );

export const parseJson = (str) => {
  try {
    const data = JSON.parse(str);
    return data;
  } catch (e) {
    console.info(e);
    return {};
  }
}


export const commonParseQuery = ({s_t, e_t, off, r_off, isHomePage= false}) => {
  const sDate = s_t ? new Date(s_t) : addDays(getTodaysDate(), 1);
  const eDate = e_t ? new Date(e_t) : addDays(getTodaysDate(), 2);
  const sd = off ? addDays(new Date(), parseInt(off, 10)) : sDate;
  sd.setHours(sDate.getHours());
  sd.setMinutes(sDate.getMinutes());
  const ed = r_off ? addDays(sd, parseInt(r_off, 10)) : eDate;
  ed.setHours(eDate.getHours());
  ed.setMinutes(eDate.getMinutes());
  const newStartDate = off ? sd : sDate;
  const newSDate = new Date() >= newStartDate ? getTodaysDate() : newStartDate;
  let newSTime = generateTimeList(newSDate.getHours(), newSDate.getMinutes());
  if(isHomePage){
    newSTime = dateformat(getDateForHome(1), 'hh:MM TT');
  }
  const newEndDate = r_off ? ed : eDate;
  const newEDate = new Date() >= newEndDate ? addDays(getTodaysDate(), 2) : newEndDate;
  let newETime = generateTimeList(newEDate.getHours(), newEDate.getMinutes());
  if(isHomePage){
    newETime = dateformat(getDateForHome(2), 'hh:MM TT')
  }
  return { newSDate, newSTime, newEDate, newETime };
}

export function generateTimeList(customHour = 0, customMinute = 0) {
  const timeList = [];
  const minuteCharList = ['00', '15', '30', '45'];
  let minutesLeft = 0;
  if (customMinute === 15) {
    minutesLeft = 1;
  } else if (customMinute === 30) {
    minutesLeft = 2;
  } else if (customMinute === 45) {
    minutesLeft = 3;
  }
  for (let i = customHour; i < 24; i += 1) {
    let hourChar = i;
    if (i > 12) {
      hourChar -= 12;
    }
    if (hourChar >= 0 && hourChar < 10) {
      hourChar = `0${hourChar}`;
    }
    for (let j = minutesLeft; j < 4; j++) {
      if (parseInt(hourChar, 10) > 9) {
        timeList.push(`${hourChar}:${minuteCharList[j]} ${i < 12 ? 'AM' : 'PM'}`);
      } else {
        timeList.push(`${hourChar}:${minuteCharList[j]} ${i < 12 ? 'AM' : 'PM'}`);
      }
    }
    minutesLeft = 0;
  }
  return timeList;
};

export const getTodaysDate = (min_offset = 15) => {
  let defaultDate = new Date();
  defaultDate.setMinutes(defaultDate.getMinutes() + min_offset);
  //Rounding off to the next multiple of 15
  if (defaultDate.getMinutes() >= 0 && defaultDate.getMinutes() < 15) {
    defaultDate.setHours(defaultDate.getHours(), 15, defaultDate.getSeconds(), defaultDate.getMilliseconds());
  } else if (defaultDate.getMinutes() >= 15 && defaultDate.getMinutes() < 30) {
    defaultDate.setHours(defaultDate.getHours(), 30, defaultDate.getSeconds(), defaultDate.getMilliseconds());
  } else if (defaultDate.getMinutes() >= 30 && defaultDate.getMinutes() < 45) {
    defaultDate.setHours(defaultDate.getHours(), 45, defaultDate.getSeconds(), defaultDate.getMilliseconds());
  } else if (defaultDate.getMinutes() > 45) {
    defaultDate.setHours(defaultDate.getHours() + 1, 0, defaultDate.getSeconds(), defaultDate.getMilliseconds());
  }
  return defaultDate;
};